import type { FormDefinition } from './types';
import { CaptomiOfficeForm } from './captomi_office';

// Registry of per-app form definitions. Each consumer drops its form file into this
// folder and registers here as part of its adoption work (SPEC §7.2). Apps in the
// `apps/` registry without a matching FormDefinition fall through to the raw-JSON
// viewer per the §6 four-state table.

const FORMS: Record<string, FormDefinition> = {
  captomi_office: CaptomiOfficeForm,
  // linkedin_mcp: LinkedInMcpForm,
  // sf_demo: SfDemoForm,
};

export function get_form_def(app_code: string): FormDefinition | null {
  return FORMS[app_code] ?? null;
}

export type { ToggleDefinition, FormDefinition, ConfigValue, ConfigPayload } from './types';
